export default __webpack_public_path__ + "static/media/friendship.771f99f0.jpg";